import jsPDF from "jspdf";
import numberToLetter from "../../../components/js/numToLetter";
import { detailQuestImg } from "../../../config/apiSPA";

class QuestionPdfGenerator {
  constructor(options = {}) {
    // General setting
    this.doc = new jsPDF();
    this.marginLeft = options.marginLeft ?? 15;
    this.marginRight = options.marginRight ?? 15;
    this.marginTop = options.marginTop ?? 20;
    this.marginBottom = options.marginBottom ?? 20;
    this.paperWidth = options.paperWidth ?? 210;
    this.paperHeight = options.paperHeight ?? 295;
    this.withKeyAnswers = options.withKeyAnswers ?? false;
    this.cursor = this.marginTop;
    this.numSpace = 2;
    this.imageMaxWidth = 120;
    // =========
    // Multiple Choice setting
    this.marginChoice = 20;
    // =========
    // True false setting
    this.tfMarginRight = 30;
    this.tfMarginLeft = 180;
    // =========
    // Matching setting
    this.imageMatchMaxWidth = 100;
    this.matchingSoalWidth = 100;
    this.matchingChoiceWidth = 50;
    this.matchingQuestionWithPicWidth = 50;
    this.matchingChoiceMarginLeft = 120;
    this.matchingQuestionWithPicMarginLeft = 125;
    // =========
    // Main data var
    this.mainData = [];
    this.user = {};
    this.multipleChoiceData = [];
    this.trueFalseData = [];
    this.matchingData = [];
  }

  async generate(data) {
    this.doc.setFont("helvetica", "bold");
    this.doc.setFontSize(20);
    this.user = data.user;
    this.mainData = data.main;
    this.multipleChoiceData = data.soalMc;
    this.trueFalseData = data.soalTf;
    this.matchingData = data.soalMatch;
    let lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
    const line = this.doc.splitTextToSize(this.mainData[0].value, this.paperWidth - (this.marginRight + this.marginLeft));
    this.doc.text(line, this.marginLeft, this.marginTop);
    this.cursor += line.length * lineHeight;
    this.footer();
    if (this.multipleChoiceData.length > 0) await this.printMultipleChoice();
    if (this.trueFalseData.length > 0) await this.printTrueFalse();
    if (this.matchingData.length > 0) await this.printMatching();
    this.doc.save(this.mainData[0].value);
    return true;
  }

  async printMultipleChoice() {
    this.chapterTitle("Multiple Choice");
    for (let i = 0; i < this.multipleChoiceData.length; i++) {
      this.questions((i + 1).toString() + ".", this.multipleChoiceData[i].pertanyaan);
      if (this.multipleChoiceData[i].img) await this.image(this.multipleChoiceData[i].img);
      this.choices(this.multipleChoiceData[i].jawaban);
    }
  }
  async printTrueFalse() {
    this.newPage();
    this.chapterTitle("True False");
    for (let i = 0; i < this.trueFalseData.length; i++) {
      const quest = this.trueFalseData[i].pertanyaan;
      const key = this.trueFalseData[i].answer;
      this.questionsTf((i + 1).toString() + ".", quest, key);
      if (this.trueFalseData[i].img) await this.image(this.trueFalseData[i].img);
    }
  }
  async printMatching() {
    this.newPage();
    this.chapterTitle("Matching");
    for (let i = 0; i < this.matchingData.length; i++) {
      if (this.matchingData[i].img) {
        if (i !== 0) {
          this.newPage();
        }
        await this.questionMatchHeaderWithPic(this.matchingData[i]);
      } else {
        if (i !== 0) {
          this.newPage();
        }
        this.questionMatchHeader(this.matchingData[i]);
      }
    }
  }
  chapterTitle(text) {
    this.doc.setFont("helvetica", "bold");
    this.doc.setFontSize(12);
    const line = this.doc.splitTextToSize(text, this.paperWidth - (this.marginRight + this.tfMarginRight));
    const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.5;
    this.checkPage(lineHeight);
    this.doc.text(line, this.marginLeft, this.cursor);
    this.cursor += line.length * lineHeight;
  }
  questionMatchHeader(data) {
    this.chapterTitle(data.petunjuk);
    const soalLength = data.soal.length;
    const choiceLength = data.jawaban.length;
    let cursorSoal = this.cursor;
    let cursorChoice = this.cursor;
    for (let i = 0; i < soalLength; i++) {
      cursorSoal += this.questionMatch(cursorSoal, data.soal[i], (i + 1).toString() + ".");
    }
    for (let i = 0; i < choiceLength; i++) {
      cursorChoice += this.choiceMatch(cursorChoice, data.jawaban[i], numberToLetter(i) + ".");
    }
  }
  async questionMatchHeaderWithPic(data) {
    this.chapterTitle(data.petunjuk);
    const choiceLength = data.soal.length;
    let cursorChoice = this.cursor;
    await this.imageMatch(data.img);
    for (let i = 0; i < choiceLength; i++) {
      cursorChoice += this.questionMatchWithPic(cursorChoice, data.soal[i], (i + 1).toString() + ".");
    }
  }
  questionMatch(cursor, soal, num) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    const textWidth = this.doc.getTextWidth(num);
    if (this.withKeyAnswers) {
      const line = this.doc.splitTextToSize(soal.pertanyaan, this.matchingSoalWidth);
      const lineKey = this.doc.splitTextToSize(soal.kunci, this.matchingSoalWidth);
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.checkPage(line.length * lineHeight + lineKey.length * lineHeight);
      const marginChoice = this.marginLeft + this.numSpace + textWidth;
      this.doc.text(num, this.marginLeft, cursor);
      this.doc.text(line, marginChoice, cursor);
      const cr = cursor + line.length * lineHeight;
      this.doc.setTextColor(255, 0, 0);
      this.doc.text(lineKey, marginChoice, cr);
      this.doc.setTextColor(0, 0, 0);
      return line.length * lineHeight + lineKey.length * lineHeight;
    } else {
      const line = this.doc.splitTextToSize(soal.pertanyaan, this.matchingSoalWidth);
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.checkPage(line.length * lineHeight);
      const marginChoice = this.marginLeft + this.numSpace + textWidth;
      this.doc.text(num, this.marginLeft, cursor);
      this.doc.text(line, marginChoice, cursor);
      return line.length * lineHeight;
    }
  }
  questionMatchWithPic(cursor, question, num) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    if (this.withKeyAnswers) {
      const textWidth = this.doc.getTextWidth(num);
      const line = this.doc.splitTextToSize(question.pertanyaan, this.matchingQuestionWithPicWidth);
      const lineKey = this.doc.splitTextToSize(question.kunci, this.matchingSoalWidth);
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.checkPage(line.length * lineHeight + lineKey.length * lineHeight);
      const marginQuestion = this.matchingQuestionWithPicMarginLeft + this.numSpace + textWidth;
      this.doc.text(num, this.matchingQuestionWithPicMarginLeft, cursor);
      this.doc.text(line, marginQuestion, cursor);
      const cr = cursor + line.length * lineHeight;
      this.doc.setTextColor(255, 0, 0);
      this.doc.text(lineKey, marginQuestion, cr);
      this.doc.setTextColor(0, 0, 0);
      return line.length * lineHeight + lineKey.length * lineHeight;
    } else {
      const textWidth = this.doc.getTextWidth(num);
      const line = this.doc.splitTextToSize(question.pertanyaan, this.matchingQuestionWithPicWidth);
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.checkPage(line.length * lineHeight);
      const marginQuestion = this.matchingQuestionWithPicMarginLeft + this.numSpace + textWidth;
      this.doc.text(num, this.matchingQuestionWithPicMarginLeft, cursor);
      this.doc.text(line, marginQuestion, cursor);
      return line.length * lineHeight;
    }
  }
  choiceMatch(cursor, choice, num) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    const textWidth = this.doc.getTextWidth(num);
    const line = this.doc.splitTextToSize(choice.jawaban, this.matchingChoiceWidth);
    const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
    this.checkPage(line.length * lineHeight);
    const marginChoice = this.matchingChoiceMarginLeft + this.numSpace + textWidth;
    this.doc.text(num, this.matchingChoiceMarginLeft, cursor);
    this.doc.text(line, marginChoice, cursor);
    return line.length * lineHeight;
  }
  questionsTf(num, text, key) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    const textWidth = this.doc.getTextWidth(num);
    const line = this.doc.splitTextToSize(text, this.paperWidth - (this.marginRight + this.marginChoice + this.tfMarginRight));
    const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
    this.checkPage(line.length * lineHeight);
    this.marginChoice = this.marginLeft + this.numSpace + textWidth;
    this.doc.text(num, this.marginLeft, this.cursor);
    this.doc.text(line, this.marginChoice, this.cursor);
    this.doc.setFont("helvetica", "bold");
    if (this.withKeyAnswers) {
      if (key) {
        this.doc.setTextColor(255, 0, 0);
        this.doc.text("T", this.tfMarginLeft, this.cursor);
        this.doc.setTextColor(0, 0, 0);
        this.doc.text(" / F", this.tfMarginLeft + this.doc.getTextWidth("T"), this.cursor);
      } else {
        this.doc.setTextColor(0, 0, 0);
        this.doc.text("T / ", this.tfMarginLeft, this.cursor);
        this.doc.setTextColor(255, 0, 0);
        this.doc.text("F", this.tfMarginLeft + this.doc.getTextWidth("T / "), this.cursor);
      }
    } else {
      this.doc.text("T / F", this.tfMarginLeft, this.cursor);
    }

    this.doc.setTextColor(0, 0, 0);
    this.cursor += line.length * lineHeight;
  }
  questions(num, text) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    const textWidth = this.doc.getTextWidth(num);
    const line = this.doc.splitTextToSize(text, this.paperWidth - (this.marginRight + this.marginChoice));
    const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
    this.checkPage(line.length * lineHeight);
    this.doc.text(num, this.marginLeft, this.cursor);
    this.doc.text(line, this.marginChoice, this.cursor);
    this.marginChoice = this.marginLeft + this.numSpace + textWidth;
    this.cursor += line.length * lineHeight;
  }
  choices(cDatas) {
    cDatas.forEach((cData, index) => {
      if (this.withKeyAnswers && cData.trueChoice) {
        this.doc.setTextColor(255, 0, 0);
      } else {
        this.doc.setTextColor(0, 0, 0);
      }
      this.choice(numberToLetter(index) + ".", cData.choices);
    });
    this.cursor += 4;
  }
  choice(num, text) {
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
    const textWidth = this.doc.getTextWidth(num);
    const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
    const line = this.doc.splitTextToSize(text, this.paperWidth - (this.marginRight + this.marginChoice + this.numSpace + textWidth));
    this.checkPage(line.length * lineHeight);
    this.doc.text(num, this.marginChoice, this.cursor);
    this.doc.text(line, this.marginChoice + textWidth + this.numSpace, this.cursor);
    this.doc.setTextColor(0, 0, 0);
    this.cursor += line.length * lineHeight;
  }
  async imageMatch(src) {
    try {
      const img = await this._loadImage(src);
      const aspect = img.naturalHeight / img.naturalWidth;
      const pxToMm = (px) => (px * 25.4) / 96;
      const widthMm = pxToMm(img.naturalWidth);
      const heightMm = pxToMm(img.naturalHeight);
      let displayWidth;
      let displayHeight;
      if (this.imageMatchMaxWidth < widthMm) {
        displayWidth = this.imageMatchMaxWidth;
        displayHeight = displayWidth * aspect;
      } else {
        displayWidth = widthMm;
        displayHeight = heightMm;
      }
      this.checkPage(displayHeight + 5);
      this.doc.addImage(img, "jpg", this.marginChoice, this.cursor, displayWidth, displayHeight);
      this.cursor += displayHeight + 5;
    } catch (error) {
      const text = ">><<[[ IMAGE ERROR ]]>><<";
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.doc.setTextColor(255, 0, 0);
      this.checkPage(lineHeight);
      this.doc.text(text, this.marginChoice, this.cursor);
      this.doc.setTextColor(0, 0, 0);
      this.cursor += lineHeight;
    }
  }
  async image(src) {
    try {
      const img = await this._loadImage(src);
      const aspect = img.naturalHeight / img.naturalWidth;
      const pxToMm = (px) => (px * 25.4) / 96;
      const widthMm = pxToMm(img.naturalWidth);
      const heightMm = pxToMm(img.naturalHeight);
      let displayWidth;
      let displayHeight;
      if (this.imageMaxWidth < widthMm) {
        displayWidth = this.imageMaxWidth;
        displayHeight = displayWidth * aspect;
      } else {
        displayWidth = widthMm;
        displayHeight = heightMm;
      }
      this.checkPage(displayHeight + 5);
      this.doc.addImage(img, "jpg", this.marginChoice, this.cursor, displayWidth, displayHeight);
      this.cursor += displayHeight + 5;
    } catch (error) {
      const text = ">><<[[ IMAGE ERROR ]]>><<";
      const lineHeight = (this.doc.getFontSize() / this.doc.internal.scaleFactor) * 1.2;
      this.doc.setTextColor(255, 0, 0);
      this.checkPage(lineHeight);
      this.doc.text(text, this.marginChoice, this.cursor);
      this.doc.setTextColor(0, 0, 0);
      this.cursor += lineHeight;
    }
  }
  _loadImage(url) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await detailQuestImg(url);
        const base64 = res.img;
        if (!base64) {
          return reject(new Error("Response tidak mengandung field data"));
        }
        // Deteksi apakah sudah lengkap data:image/...
        const imgSrc = base64.startsWith("data:image") ? base64 : `data:image/jpeg;base64,${base64}`;
        const img = new Image();
        // img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Gagal memuat gambar dari Base64"));
        img.src = imgSrc;
      } catch (error) {
        reject(error);
      }
    });
  }
  checkPage(newHeight) {
    if (newHeight + this.cursor > this.paperHeight - this.marginBottom) {
      this.newPage();
    }
  }
  footer() {
    this.doc.setFont("helvetica", "italic");
    this.doc.setFontSize(8);

    this.doc.text("This document auto generate from ppdmaco.com at:" + new Date() + " by: " + this.user.name, this.marginLeft, 290);
  }
  newPage() {
    this.doc.addPage();
    this.cursor = this.marginTop;
    this.footer();
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(12);
  }
}

export default async function generateQuestionToPDF(data, { withKeyAnswers = false } = {}) {
  const generator = new QuestionPdfGenerator({ withKeyAnswers });
  return await generator.generate(data);
}
